import HomePage from '@/views/HomePage.vue';
import TestPage from '@/views/TestPage.vue';
import FilesList from '@/views/FilesList.vue';
import FilesSent from '@/views/FilesSent.vue';


const devRoutes = [];
if (import.meta.env.MODE !== 'production')
{
    // ------------------------------------------------------------ TEST PAGE

    devRoutes.push({
        path:      '/test',
        component: TestPage,
    });
}


export default
[
    // ------------------------------------------------------------ HOME PAGE

    {
        path:      '/',
        alias:     '/home',
        name:      'home',
        component: HomePage,
    },

    ...devRoutes,

    // ------------------------------------------------------------ UPLOADED FILES LIST

    {
        path:      '/file/topographer/:topographerId/patient/:patientId',
        name:      'files-list',
        component: FilesList,
    },

    // ------------------------------------------------------------ FILES SENT SUCCESSFULLY

    {
        path:      '/thank-you/:requestType',
        name:      'files-sent',
        component: FilesSent,
    },
];
